import { createFileRoute } from '@tanstack/react-router';

import { ScheduleScreen } from '../../features/schedule/schedule-screen';

/**
 * `/mylab/schedule` — S6 일정 (E14 §2)
 *
 * 라우트는 얇게 둔다: 화면은 `features/schedule`에 있다. 게이트는 부모 `mylab.tsx`가 맡는다.
 * 홈(S4)의 확대 버튼이 선택 날짜를 `date` search param으로 넘긴다.
 */
interface ScheduleSearch {
  date?: string;
}

export const Route = createFileRoute('/mylab/schedule')({
  validateSearch: (search: Record<string, unknown>): ScheduleSearch => ({
    date: typeof search.date === 'string' ? search.date : undefined,
  }),
  component: ScheduleRoute,
});

function ScheduleRoute() {
  const { date } = Route.useSearch();
  return <ScheduleScreen initialDate={date} />;
}
